import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import {
  ROLES_OPTION,
  ROLES_LIST,
} from 'src/components/enterprise/features/Employee/utils/employeeRoles.utils';

export interface PermissionsControlProps {
  name: string;
  id: string;
  disabled?: boolean;
  filterOptions?: (ROLES_LIST: ROLES_OPTION[]) => ROLES_OPTION[];
}

export function PermissionsControl({
  filterOptions,
  name,
  id,
  disabled,
}: PermissionsControlProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label="Role *"
      name={name}
      id={id}
      disabled={disabled}
      error={get(errors, name)}
      options={filterOptions?.(ROLES_LIST) || ROLES_LIST}
      control={control}
      blockWidth
      rules={{
        required: 'Role is required',
      }}
    />
  );
}
